import Reflux from 'reflux'

export default Reflux.createActions([
	'reset',
	'get',

	'toggleInstructionModal',
	'addInstruction',
	'updateInstruction',
	'deleteRecipeInstruction',
	'getRecipeInstructions',

	'toggleIngredientsModal',
	'addIngredient',
	'updateIngredient',
	'deleteRecipeIngredients',
	'getRecipeIngredients'
])



// WEBPACK FOOTER //
// ./src/actions/currentRecipe.js